import * as React from 'react';
import { clsx } from 'clsx';
import { IconActionChevronLeft24, IconActionChevronRight24 } from '@cian/ui-kit-design-tokens/icons';

import { TTabsTheme } from '../../types';
import { getTheme } from '../../styles/scrollButton/getTheme';
import * as styles from '../../styles/scrollButton/button.css';

interface IButtonProps {
  right?: boolean;
  onClick(e: React.MouseEvent): void;
  theme: TTabsTheme;
}

export const ScrollButton: React.FC<IButtonProps> = ({ onClick, right, theme }) => {
  const themeStyles = getTheme(theme);

  return (
    <button
      className={clsx(styles['button'], themeStyles['button'], right ? styles['button-right'] : styles['button-left'])}
      onClick={onClick}
      tabIndex={-1}
    >
      {right ? <IconActionChevronRight24 color="theme-white" /> : <IconActionChevronLeft24 color="theme-white" />}
    </button>
  );
};
